export enum ReportEvents {
  PRESS_COPY_LINK_REPORT = "press_copy_link_report",
  REPORT_STREAM_LOGS_IN_SYNC = "report_stream_logs_in_sync",
  REPORT_MOVE_TAB = "report_move_tab",
}
